<ion-header class="ion-no-border page">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title mode="ios">
      <div  (click)="goHome()" class="header-logo">&nbsp;</div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="showMenu()" class="menu" [attr.aria-label]="'ARIA.MENU.BUTTON.LABEL_0' | translate">
        <ion-icon slot="icon-only" aria-hidden="true"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="page-title" translate>DIALOGS.TITLE</div>

</ion-header>

<ion-content class="ion-padding" no-bounce class="master">
  <ng-template [ngIf]="groupDates.length == 0">
    <div class="no-entries-label">
      <ion-label translate>DIALOGS.NO_ENTRIES</ion-label>
    </div>
  </ng-template>

  <div class="v-box full-height" *ngIf="groupDates.length > 0">

    <ng-template ngFor let-item [ngForOf]="groupDates" #groups>
      <h2 class="date-label">{{getDateLabel(item)}}</h2>

      <ng-template ngFor let-item [ngForOf]="dialogGroupsByDay[item]" let-last="last">
        <leada-button (click)="onItemClicked(item)">
          <div>{{getDialogTitle(item)}}</div>
          <div class="debug-info" *ngIf="isShowTime">{{item.sortTime}}</div>
        </leada-button>
        <div class="divider" *ngIf="!last"></div>
      </ng-template>
    </ng-template>

</div>
</ion-content>
